import {Component, effect, input, output} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {AccountingAccountFormValue} from '../../models/accounting-account-form-value';
import {TranslatePipe} from '@ngx-translate/core';
import {TextInput} from '../../../../../../../../components/text-input/text-input';
import {AccountingAccountDetails, AccountType} from '../../../../../../../../../api';
import {AccountTypeDropdown} from '../account-type-dropdown/account-type-dropdown';

@Component({
  selector: 'elcia-accounting-account-form',
  imports: [ReactiveFormsModule, TranslatePipe, TextInput, AccountTypeDropdown],
  templateUrl: './accounting-account-form.html',
})
export class AccountingAccountForm {
  initialValue = input<AccountingAccountDetails | undefined>();
  onSubmit = output<AccountingAccountFormValue>();

  protected accountingAccountForm = new FormGroup({
    name: new FormControl('', {nonNullable: true, validators: [Validators.required]}),
    account: new FormControl('', {nonNullable: true, validators: [Validators.required]}),
    accountType: new FormControl<AccountType | null>(null),
  });


  onInitialValueChange = effect(() => {
    const val = this.initialValue();
    if (!val) return;
    this.accountingAccountForm.patchValue({
      name: val.name,
      account: val.account,
      accountType: val.accountType,
    });
  });

  public submit(): void {
    if (this.accountingAccountForm.invalid) {
      this.accountingAccountForm.markAllAsTouched();
      return;
    }
    const formValue = this.accountingAccountForm.value;
    this.onSubmit.emit({
      id: this.initialValue()?.id ?? null,
      name: formValue.name!,
      account: formValue.account!,
      accountType: formValue.accountType!,
    });
  }
}
